export default "__VITE_ASSET__Di$LAZR2__"